function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_29109_78327)"
}, React.createElement("path", {
  d: "M14.6666 8.00004C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667M14.6666 8.00004C14.6666 4.31814 11.6819 1.33337 7.99998 1.33337M14.6666 8.00004H1.33331M7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00004M7.99998 14.6667C6.28814 12.8693 5.33331 10.4822 5.33331 8.00004C5.33331 5.51787 6.28814 3.13081 7.99998 1.33337M7.99998 14.6667C9.71182 12.8693 10.6666 10.4822 10.6666 8.00004C10.6666 5.51787 9.71182 3.13081 7.99998 1.33337M1.33331 8.00004C1.33331 4.31814 4.31808 1.33337 7.99998 1.33337",
  stroke: "#EFF2F7",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_29109_78327"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgGlobeDark = function SvgGlobeDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlobeDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/globe_dark.188eb342.svg";
export { ForwardRef as ReactComponent };